import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_BRANCHES,
  CREATE_BRANCH,
  UPDATE_BRANCH,
  DELETE_BRANCH,
} from "./actionTypes"
import {
  getBranchesFail,
  getBranchesSuccess,
  createBranchFail,
  createBranchSuccess,
  updateBranchSuccess,
  updateBranchFail,
  deleteBranchSuccess,
  deleteBranchFail,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

// Branch - This line cannot be edited or removed
function getBranchesAPi({ page, limit, searchText, stateId, districtId }) {
  return get(
    `/branch/super-admin/all/?page=${page ? page : 1}&limit=${
      limit ? limit : 10
    }&search=${searchText}&state=${stateId && stateId}&district=${
      districtId ? districtId : ""
    }`
  )
}

const createBranchApi = ({ branch }) => {
  return post("/branch/super-admin/new", branch)
}

const updateBranchApi = ({ branch, branchId }) => {
  return ApiPut(`/branch/super-admin/${branchId}`, branch)
}

const deleteBranchApi = ({ branchId }) => {
  return del(`/branch/super-admin/${branchId}`)
}

function* fetchBranches({ payload }) {
  try {
    const response = yield call(getBranchesAPi, payload)
    yield put(getBranchesSuccess(response))
  } catch (error) {
    yield put(getBranchesFail(error))
  }
}

function* onCreateBranch({ payload }) {
  try {
    const response = yield call(createBranchApi, payload)

    yield put(createBranchSuccess(response))
    payload?.onCloseClick()
    doneNotification("Branch Created Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createBranchFail(error))
  }
}

function* onUpdateBranch({ payload }) {
  try {
    const response = yield call(updateBranchApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Branch Updated Successfully!",
        title: "",
      })
      yield put(updateBranchSuccess(response))
      payload?.onCloseClick()

      if (payload.history) {
        payload.history.push("/branchs")
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateBranchFail(error.response.data))
  }
}

function* onDeleteBranch({ payload }) {
  try {
    const response = yield call(deleteBranchApi, payload)
    yield put(deleteBranchSuccess(response))
    doneNotification("Branch Deleted Successfully!")
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteBranchFail(error?.response?.data))
  }
}

function* branchSaga() {
  yield takeEvery(GET_BRANCHES, fetchBranches)
  yield takeEvery(CREATE_BRANCH, onCreateBranch)
  yield takeEvery(UPDATE_BRANCH, onUpdateBranch)
  yield takeEvery(DELETE_BRANCH, onDeleteBranch)
}

export default branchSaga

function doneNotification(message) {
  Notification({
    type: "success",
    message: message,
    title: "",
  })
}
